import React from 'react';
import { createUseStyles } from 'react-jss';
import {
    Box,
    Grid,
    Pagination,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import OfferCard from './OfferCard';

const useStyles = createUseStyles({
    container: {
        padding: '16px',
    },
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
        gap: '16px',
        marginBottom: '24px',
        width: '100%',
        '@media (max-width: 480px)': {
            gap: '8px',
        },
    },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        marginTop: '24px',
        padding: '16px',
    },
    pageSizeSelect: {
        minWidth: '120px',
    },
    pageInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: '#666',
    },
    noResults: {
        textAlign: 'center',
        padding: '40px',
        color: '#666',
    },
});

const OfferCardView = ({
    data,
    dataGroup,
    sort,
    updateButton,
    reportButton,
    deleteButton,
    changeOfferActive,
    notificationButton,
    canManageOffer,
    onDuplicate,
    loading = false,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box
            className={classes.container + ' offers-card-box'}
            style={{ padding: '0px', paddingTop: '16px' }}
        >
            {data.length === 0 && !loading ? (
                <Box className={classes.noResults}>
                    <Typography variant="h6">{t('offers.no_offers_found')}</Typography>
                    <Typography variant="body2">{t('offers.try_changing_filters')}</Typography>
                </Box>
            ) : (
                <Box className={classes.gridContainer}>
                    {data.map((offer) => (
                        <OfferCard
                            key={offer.id}
                            offer={offer}
                            dataGroup={dataGroup}
                            sort={sort}
                            updateButton={updateButton}
                            reportButton={reportButton}
                            deleteButton={deleteButton}
                            changeOfferActive={changeOfferActive}
                            notificationButton={notificationButton}
                            canManageOffer={canManageOffer}
                            onDuplicate={onDuplicate}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default OfferCardView;
